import { instance } from "./api"
import { useAuthStore } from '../stores/t-auth';
import axios from 'axios'
import type { CapaResponse, PrediosResponse } from "../types"

async function listPredios() {
    const auth = useAuthStore();

    return await instance.get<PrediosResponse>("/predios", {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}

async function getPredios() {
    const auth = useAuthStore();

    return await instance.get<CapaResponse>("/capas/predios", {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}
async function getRegiones(ne_lon: number, ne_lat: number, so_lon: number, so_lat: number) {
    const auth = useAuthStore();

    return await instance.get<CapaResponse>("/capas/regiones", {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        },
        params: {
            ne_lon,
            ne_lat,
            so_lon,
            so_lat
        }
    });
}
async function getComunas() {
    const auth = useAuthStore();

    return await instance.get<CapaResponse>("/capas/comunas", {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });

}
async function getCiudades() {
    const auth = useAuthStore();

    return await instance.get<CapaResponse>("/capas/ciudades", {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}
async function getCarreteras() {
    const auth = useAuthStore();

    return await instance.get<CapaResponse>("/capas/carreteras", {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}

async function getCaminosPrincipales() {
    const auth = useAuthStore();

    return await instance.get<CapaResponse>("/capas/caminos-principales", {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}

async function getCaminosVecinales() {
    const auth = useAuthStore();

    return await instance.get<CapaResponse>("/capas/caminos-vecinales", {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}

async function getAguas() {
    const auth = useAuthStore();

    return await instance.get<CapaResponse>("/capas/aguas", {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}
export async function getElevation(lat: string, lng: string) {
    const url = `https://api.open-elevation.com/api/v1/lookup?locations=${lat},${lng}`;
    const response = await axios.get(url);

    return response.data.results[0].elevation;
}
export default {
    listPredios,
    getPredios,
    getRegiones,
    getComunas,
    getCiudades,
    getCarreteras,
    getCaminosPrincipales,
    getCaminosVecinales,
    getAguas,
    getElevation
};